(function() {
    'use strict';

    angular
        .module('app.tiposAccionPersonal')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/tipos-accion-personal',
                config: {
                    templateUrl: 'app/tiposAccionPersonal/tiposAccionPersonal.html',
                    controller: 'TiposAccionPersonal',
                    controllerAs: 'vm',
                    title: 'TiposAccionPersonal'
                }
            },
            {
                url: '/editar-tipo-accion-personal/:id?',
                config: {
                    templateUrl: 'app/tiposAccionPersonal/editarTipoAccionPersonal.html',
                    controller: 'EditarTipoAccionPersonal',
                    controllerAs: 'vm',
                    title: 'EditarTipoAccionPersonal'
                }
            }
        ];
    }
})();
